import { Box, IconButton, Skeleton, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import ImageView from "../../assets/img/taskView.png";
import { useDispatch, useSelector } from "react-redux";
import { setPageTitle } from "../../reduxStore/SettingsReducer";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MessageIcon from "@mui/icons-material/Message";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import leadershipImage from "../../assets/img/leadership.png";
import companyImage from "../../assets/img/business-and-trade.png";
import TaskImage from "../../assets/img/clipboard.png";
import user1Image from "../../assets/img/user (1).png";
import groupImages from "../../assets/img/group.png";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import EditIcon from "@mui/icons-material/Edit";
import GroupsIcon from "@mui/icons-material/Groups";
import AttachmentIcon from "@mui/icons-material/Attachment";
import ScaleIcon from "@mui/icons-material/Scale";
import * as RiIcons from "react-icons/ri";
import * as AiIcons from "react-icons/ai";
import * as ImIcons from "react-icons/im";

import { Button } from "evergreen-ui";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Details from "./Details";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import AssingUser from "./AssignUser";
import EditTask from "./EditTask";
import ShowFile from "./ShowFile";
import PersonIcon from "@mui/icons-material/Person";
import Comments from "./Comments";
import AttachFile from "./AttachFile";
import Status from "./Status";
import moment from "moment";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CommentIcon from "@mui/icons-material/Comment";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import axios from "../../assets/js/AxiosInterceptors";
import Host from "../../assets/js/Host";
import Lottie from "lottie-react-web";

import Preloading from "../Preload/Preloading";
import GroupIcon from "@mui/icons-material/Group";
import feHost from "../../assets/js/feHost";
import helpers from "../../assets/js/helper";
import DeleteIcon from "@mui/icons-material/Delete";
import LogForm from "./LogForm";
import ShowFilev2 from "./ShowFilev2";
import DetailsList from "../Finances/components/DetailsList";
import FinancesList from "../Finances/components/FinancesList";

const cookies = new Cookies();
var spin;

export default function NewTicketView({
  skeletonLoading,
  setSkeletonLoading,
  ...props
}) {
  const dispatch = useDispatch();
  const screenwidth = useSelector((state) => state.settingsData.screenwidth);
  const [commentOrWorkLog, setCommentOrWorkLog] = useState(false);
  const [isRtl, setIsRtl] = useState(true);
  const [showFiles, setShowFiles] = useState(false);
  const [showLogForm, setShowLogForm] = useState(false);
  const [expanded, setExpanded] = React.useState("panel1");
  const [showAssing, setShowAssing] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showAttachFile, setShowAttachFile] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : true);
  };
  const [isShown, setIsShown] = React.useState(false);

  const isopensidemenu = useSelector(
    (state) => state.settingsData.isopensidemenu
  );
  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "#188718b5";
      case "rejected":
        return "#da251e";
      case "closed":
        return "gray";
      case "new":
        return "#2e6b95";
      case "in progress":
        return "#f06105cc";
      case "assigned":
        return "#d5ad00d4";
      case "archived":
        return "black";
      default:
        return "lightgrey";
    }
  };
  const getStatusColorRgba = (status, number) => {
    switch (status) {
      case "approved":
        return `rgba(24, 135, 24,${number})`;
      case "rejected":
        return `rgba(218, 37, 30,${number})`;
      case "closed":
        return `rgba(128, 128, 128, ${number})`;
      case "new":
        return `rgba(46, 107, 149, ${number})`;
      case "in progress":
        return `rgba(240, 97, 5, ${number})`;
      case "assigned":
        return `rgba(213, 173, 0, ${number}) `;
      case "archived":
        return `rgba(0, 0, 0, ${number})`;
      default:
        return `rgba(211, 211, 211, ${number})`;
    }
  };
  function Delete(data) {
    spin = true;
    var headers = {
      "Content-Type": "application/json",
      jwt: cookies.get("token"),
    };

    axios({
      url: Host + `tasks/task/${data}`,
      method: "DELETE",
      headers: headers,
    })
      .then((response) => {
        if (response.data.status === false) {
          toast.error(response.data.data.text);
          spin = false;
        } else if (response.data.status === true) {
          const { onRefTask } = props;
          onRefTask();
          toast.success("deleted successfully");
          spin = false;
        }
      })
      .catch((err) => {
        toast.error("Network Error");
        spin = false;
      });
  }
  useEffect(() => {
    dispatch(setPageTitle("Task Details"));
    // setSkeletonLoading(true);
    setTimeout(() => {
      // setSkeletonLoading(false);
    }, 2000);
    if (isRtl) {
      var x = document.createElement("STYLE");
      var t = document.createTextNode("p {text-align: end;}");
      x.appendChild(t);
      document.head.appendChild(x);
    } else {
      var x = document.createElement("STYLE");
      var t = document.createTextNode("p {text-align: start;}");
      x.appendChild(t);
      document.head.appendChild(x);
    }
    return () => {
      dispatch(setPageTitle(""));
    };
  }, []);
  const getCurrentStatusName = () => {
    if (props?.status == "approved") {
      return "Approved";
    } else if (props?.status == "rejected") {
      return "Rejected";
    } else if (props?.status == "closed") {
      return "Closed - " + props?.close_status_name;
    } else if (props?.status == "new") {
      return "new";
    } else if (props?.status == "in progress") {
      return "In progress";
    } else if (props?.status == "assigned") {
      return "Assigned";
    } else if (props?.status == "archived") {
      return "Archived";
    }
  };
  const getExtractedText = (name) => {
    const text = name;
    const regex = /\((.*?)\)/;
    const match = text.match(regex);

    if (match && match.length > 1) {
      const extractedText = match[1];
      return extractedText;
    } else {
      return text;
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        marginTop: "53px",
        transition: "all 0.4s ease-in-out",
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "wrap",
      }}
    >
      {showAssing ? (
        <AssingUser
          addForm={showAssing}
          setAddForm={setShowAssing}
          users={props?.users}
          id={props.id}
          onRefTask={props}
          assigned={props.assigned}
        />
      ) : null}
      {props.status !== "new" && props.task_type === "حذف" ? null : showEdit ? (
        <EditTask
          addForm={showEdit}
          setAddForm={setShowEdit}
          allstatus={props.allstatus}
          onRefTask={props}
          id={props.id}
          title={props?.name}
          num_of_units={props.num_of_units}
          contacted_person={props.contacted_person}
          contacted_num={props.contacted_num}
          time={props.time}
          desc={props.desc}
          status={props.status}
          type={props.type}
          task_type={props.task_type}
          users={props.users}
          Geofences={props.Geofences}
          geofences={props.geofences}
          onRefreshGeo={props}
          weight={props.weight}
          monitor={props.monitor}
        />
      ) : null}
      {showAttachFile ? (
        <AttachFile
          addForm={showAttachFile}
          setAddForm={setShowAttachFile}
          id={props.id}
          onRefTask={props}
        />
      ) : null}
      {showLogForm ? (
        <LogForm
          addForm={showLogForm}
          setAddForm={setShowLogForm}
          id={props?.id}
        />
      ) : null}

      {showFiles ? (
        <ShowFilev2
          files={props.files}
          onRefTask={props}
          showFiles={showFiles}
          setShowFiles={setShowFiles}
          status={props?.status}
        />
      ) : null}

      {/*==============================================
       ===============header here====================
       ============================================== */}
      <Box
        sx={{
          width: "100%",
          height: "300px",
          backgroundColor: "#f3f3f3",
          position: "relative",
          overflow: "hidden",
          borderRadius: "5px",
        }}
      >
        {skeletonLoading ? (
          <Skeleton
            animation="wave"
            sx={{
              width: "100%",
              height: "300px",
              position: "absolute",
              zIndex: "1 !important",
              webkitTransform: "scale(1) !important",
              transform: "scale(1) !important",
            }}
            height={"100%"}
            width="100%"
          />
        ) : (
          <img
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100%",
              height: "100%",
              zIndex: 1,
              objectFit: "cover",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
            }}
            src={ImageView}
          />
        )}
        {!skeletonLoading ? (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100%",
              height: "100%",
              zIndex: 2,
              background: `linear-gradient(0deg, ${
                props?.status
                  ? getStatusColorRgba(props?.status, 1)
                  : "rgba(30,106,153,1)"
              } 0%, ${
                props?.status
                  ? getStatusColorRgba(props?.status, 0.9192927170868347)
                  : "rgba(30,106,153,0.9192927170868347)"
              } 16%, ${
                props?.status
                  ? getStatusColorRgba(props?.status, 0.8688725490196079)
                  : "rgba(30,106,153,0.8688725490196079)"
              } 32%, ${
                props?.status
                  ? getStatusColorRgba(props?.status, 0.8268557422969187)
                  : "rgba(30,106,153,0.8268557422969187)"
              } 51%, ${
                props?.status
                  ? getStatusColorRgba(props?.status, 0.5859593837535014)
                  : "rgba(30,106,153,0.4859593837535014)"
              } 70%, ${
                props?.status
                  ? getStatusColorRgba(props?.status, 0.5943627450980392)
                  : "rgba(30,106,153,0.4943627450980392)"
              } 85%, ${
                props?.status
                  ? getStatusColorRgba(props?.status, 0.5271358543417367)
                  : "rgba(30,106,153,0.3271358543417367)"
              } 100%)`,
            }}
          ></Box>
        ) : null}

        {skeletonLoading ? (
          <Skeleton
            animation="wave"
            sx={{
              position: "absolute",
              top: "0",
              left: "300px",
              width: "150px",
              height: "100px",
              backgroundColor: "#b6c2d0",
              zIndex: "100",
              WebkitClipPath: "polygon(100% 0, 0 0, 50% 100%)",
              clipPath: "polygon(100% 0, 0 0, 50% 100%)",
              filter: "drop-shadow(0 0 7px -2px #fff)",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              paddingTop: "15px",
              webkitTransform: "scale(1) !important",
              transform: "scale(1) !important",
            }}
          />
        ) : (
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "380px",
              width:
                props?.status == "closed"
                  ? "230px"
                  : props?.status == "in progress"
                  ? "180px"
                  : "150px",
              height: props?.status == "closed" ? "120px" : "100px",
              backgroundColor: props?.status
                ? getStatusColor(props?.status)
                : "#1e6a99",
              zIndex: "100",
              WebkitClipPath: "polygon(100% 0, 0 0, 50% 100%)",
              clipPath: "polygon(100% 0, 0 0, 50% 100%)",
              filter: "drop-shadow(0 0 7px -2px #fff)",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              paddingTop: "15px",
            }}
          >
            <p
              style={{
                fontSize:
                  props?.status == "closed"
                    ? "18px"
                    : props?.status == "in progress"
                    ? "20px"
                    : "22px",
                color: "#fff",
              }}
            >
              {getCurrentStatusName()}
            </p>
          </Box>
        )}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "50px",
            zIndex: 3,
            position: "relative",
            padding: "0 30px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {skeletonLoading ? (
              <>
                <Skeleton
                  animation="wave"
                  variant="circular"
                  sx={{
                    webkitTransform: "scale(1) !important",
                    transform: "scale(1) !important",
                  }}
                  width={40}
                  height={40}
                />
                <Skeleton
                  animation="wave"
                  variant="circular"
                  sx={{
                    webkitTransform: "scale(1) !important",
                    transform: "scale(1) !important",
                  }}
                  width={40}
                  height={40}
                />
                <Skeleton
                  animation="wave"
                  variant="circular"
                  sx={{
                    webkitTransform: "scale(1) !important",
                    transform: "scale(1) !important",
                  }}
                  width={40}
                  height={40}
                />
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{
                    webkitTransform: "scale(1) !important",
                    transform: "scale(1) !important",
                    borderRadius: "20px",
                  }}
                  width={90}
                  height={40}
                />
              </>
            ) : (
              <>
                {props?.geofences?.geo_name !== "null" &&
                props?.geofences?.geo_name !== null ? (
                  <Tooltip title={"Location-" + props?.geofences?.geo_name}>
                    <IconButton
                      sx={{
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #fff",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff",
                        },
                        "&:hover svg": {
                          transform: "scale(1.1)",
                        },
                      }}
                      onClick={() => {
                        if (props.geofences.geo_y < props.geofences.geo_x) {
                          window.open(
                            `https://maps.google.com/?q=${props.geofences.geo_y},${props.geofences.geo_x}`,
                            "_blank"
                          );
                        } else {
                          window.open(
                            `https://maps.google.com/?q=${props.geofences.geo_x},${props.geofences.geo_y}`,
                            "_blank"
                          );
                        }
                      }}
                    >
                      <LocationOnIcon sx={{ color: "#000" }} />
                    </IconButton>
                  </Tooltip>
                ) : null}
                {props?.files?.length > 0 ? (
                  <Tooltip title={"Attach files"}>
                    <IconButton
                      sx={{
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #fff",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff",
                        },
                        "&:hover svg": {
                          transform: "scale(1.1)",
                        },
                      }}
                      onClick={() => {
                        setShowFiles(true);
                      }}
                    >
                      <AttachFileIcon sx={{ color: "#000" }} />
                    </IconButton>
                  </Tooltip>
                ) : null}
                {props?.time == "1970-01-01T00:00:00.000Z" ? null : (
                  <Tooltip
                    title={"Deadline - " + moment(props?.time).format("lll")}
                  >
                    <IconButton
                      sx={{
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #fff",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff",
                        },
                        "&:hover svg": {
                          transform: "scale(1.1)",
                        },
                      }}
                    >
                      <PendingActionsIcon
                        sx={{
                          color:
                            moment().format("X") >=
                            moment(props?.time).format("X")
                              ? "#da251e"
                              : "green",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                )}
                {props?.comments_count > 0 ? (
                  <Tooltip title={"Comments"}>
                    <IconButton
                      sx={{
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #fff",
                        width: "70px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "20px",
                        gap: "10px",
                        "&:hover": {
                          backgroundColor: "#fff",
                        },
                        "&:hover svg": {
                          transform: "scale(1.1)",
                        },
                      }}
                    >
                      <MessageIcon sx={{ color: "#000" }} />
                      <span style={{ fontSize: "20px", color: "#1e6a99" }}>
                        {props?.comments_count}
                      </span>
                    </IconButton>
                  </Tooltip>
                ) : null}
                <Tooltip title={"Weights"}>
                  <IconButton
                    sx={{
                      backgroundColor: "#fff",
                      boxShadow: "0 0 7px -2px #fff",
                      minWidth: "70px",
                      width: "fit-content",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "20px",
                      gap: "10px",
                      "&:hover": {
                        backgroundColor: "#fff",
                      },
                      "&:hover svg": {
                        transform: "scale(1.1)",
                      },
                    }}
                  >
                    <ScaleIcon sx={{ color: "#000", fontSize: "22px" }} />
                    <span style={{ fontSize: "20px", color: "#1e6a99" }}>
                      {props?.weight}
                    </span>
                  </IconButton>
                </Tooltip>
              </>
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            {skeletonLoading ? (
              <Skeleton
                animation="wave"
                sx={{
                  webkitTransform: "scale(1) !important",
                  transform: "scale(1) !important",
                }}
                width={300}
                height={30}
              />
            ) : (
              <>
                <p style={{ fontSize: "25px", color: "#fff" }}>
                  نوع المهمة {props.task_type}
                </p>
                <p
                  style={{
                    height: "2px",
                    width: "90px",
                    backgroundColor:
                      props?.status == "in progress" ||
                      props?.status == "rejected"
                        ? "#fff"
                        : "#D46A43",
                    borderRadius: "5px",
                    position: "relative",
                    top: "-10px",
                  }}
                ></p>
              </>
            )}
          </Box>
        </Box>
      </Box>

      {/*==============================================
       ===============First Section here=============
       ============================================== */}
      <Box
        sx={{
          width: screenwidth <= 1400 || isopensidemenu ? "100%" : "38%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {skeletonLoading ? (
          <Skeleton
            animation="wave"
            sx={{
              width: "90%",
              height: "fit-content",
              minHeight: "300px",
              backgroundColor: "#f2f2f2",
              boxShadow: "0 2px 7px -2px #626262  !important",
              position: "relative",
              top: "-90px",
              zIndex: "99",
              borderRadius: "5px",
              webkitTransform: "scale(1) !important",
              transform: "scale(1) !important",
            }}
          />
        ) : (
          <Box
            sx={{
              width: "90%",
              height: "fit-content",
              minHeight: "300px",
              backgroundColor: "#fff",
              boxShadow: "0 2px 7px -2px #626262 ",
              position: "relative",
              top: "-90px",
              zIndex: "99",
              borderRadius: "5px",
              paddingBottom: "18px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                padding: "15px 20px 0 20px",
              }}
            >
              {skeletonLoading ? (
                <Skeleton
                  animation="wave"
                  sx={{
                    webkitTransform: "scale(1) !important",
                    transform: "scale(1) !important",
                  }}
                  width={300}
                  height={30}
                />
              ) : (
                <>
                  <p style={{ fontSize: "25px", color: "#000" }}>
                    Task Information
                  </p>
                  <p
                    style={{
                      height: "2.5px",
                      width: "100px",
                      backgroundColor: "#D46A43",
                      borderRadius: "5px",
                      position: "relative",
                      top: "-10px",
                    }}
                  ></p>
                </>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                padding: "0 20px",
                gap: "11px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "19px",
                }}
              >
                <img
                  src={companyImage}
                  style={{
                    width: "25px",
                    height: "25px",
                    transform: "scale(1.1)",
                    backgroundPosition: "center center",
                    objectFit: "cover",
                  }}
                />
                <span style={{ fontFamily: "Cairo", color: "#404040" }}>
                  {props?.name}
                </span>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "19px",
                }}
              >
                <img
                  src={TaskImage}
                  style={{
                    width: "25px",
                    height: "25px",
                    transform: "scale(1.1)",
                    backgroundPosition: "center center",
                    objectFit: "cover",
                  }}
                />
                <span style={{ fontFamily: "Cairo", color: "#404040" }}>
                  #{props?.id}
                </span>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "19px",
                }}
              >
                <img
                  src={user1Image}
                  style={{
                    width: "25px",
                    height: "25px",
                    transform: "scale(1.1)",
                    backgroundPosition: "center center",
                    objectFit: "cover",
                  }}
                />
                <span style={{ fontFamily: "Cairo", color: "#404040" }}>
                  {props?.createdby}
                </span>
              </Box>
              {props?.monitor?.name !== null ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "19px",
                  }}
                >
                  <img
                    src={leadershipImage}
                    style={{
                      width: "25px",
                      height: "25px",
                      transform: "scale(1.1)",
                      backgroundPosition: "center center",
                      objectFit: "cover",
                    }}
                  />
                  <span style={{ fontFamily: "Cairo", color: "#404040" }}>
                    {props?.monitor?.name}
                  </span>
                </Box>
              ) : null}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "19px",
                }}
              >
                <img
                  src={groupImages}
                  style={{
                    width: "25px",
                    height: "25px",
                    transform: "scale(1.1)",
                    backgroundPosition: "center center",
                    objectFit: "cover",
                  }}
                />
                {props.assigners.length > 0 ? (
                  <span style={{ fontFamily: "Cairo", color: "#404040" }}>
                    {props.assigners[0].name}
                    {props.assigners.length > 1 ? (
                      <span id="OthersParent">
                        {" "}
                        + {props.assigners.length - 1} Others{" "}
                        <span id="OthersContent">
                          {" "}
                          {props.assigners.map((p, i) => (
                            <div key={i}> {p.name} </div>
                          ))}{" "}
                        </span>{" "}
                      </span>
                    ) : null}
                  </span>
                ) : (
                  <span style={{ fontFamily: "Cairo", color: "#404040" }}>
                    No Body
                  </span>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <Box
                  sx={{
                    borderRadius: "20px",
                    height: "40px",
                    width: "fit-content",
                    minWidth: "120px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    boxShadow: "0 1px 7px -2px #000",
                    padding: "11px 20px",
                    gap: "10px",
                  }}
                >
                  <CalendarMonthIcon sx={{ color: "grey", fontSize: "19px" }} />
                  <span>{moment(props.created_at).format("lll")}</span>
                </Box>
                <Box
                  sx={{
                    borderRadius: "20px",
                    height: "40px",
                    width: "fit-content",
                    minWidth: "120px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    boxShadow: "0 1px 7px -2px #000",
                    padding: "11px 20px",
                    gap: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (
                      props?.task_type_id === 15 &&
                      props?.request_type?.mandatory_units == 1
                    ) {
                      setIsShown(true);
                    }
                  }}
                >
                  <AiIcons.AiOutlineDeploymentUnit
                    size={19}
                    style={{ color: "grey", fontSize: "19px" }}
                  />
                  <span>
                    عدد الوحدات :{" "}
                    {props?.units?.length ? props?.units?.length : 0}
                  </span>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          width: screenwidth <= 1400 || isopensidemenu ? "100%" : "62%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "relative",
          top: screenwidth <= 1400 ? "-105px" : "-115px",
        }}
      >
        {/*==============================================
       ===============second Section here=============
       ============================================== */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {skeletonLoading ? (
            <Skeleton
              animation="wave"
              sx={{
                width: "90%",
                height: "fit-content",
                minHeight: "300px",
                backgroundColor: "#f2f2f2",
                boxShadow: "0 2px 7px -2px #626262  !important",
                position: "relative",
                zIndex: "99",
                marginTop: "25px",
                borderRadius: "5px",
                webkitTransform: "scale(1) !important",
                transform: "scale(1) !important",
              }}
            />
          ) : (
            <Box
              sx={{
                width: "90%",
                height: "fit-content",
                minHeight: "300px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 7px -2px #626262 ",
                position: "relative",
                zIndex: "99",
                marginTop: "25px",
                borderRadius: "5px",
                paddingBottom: "20px",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <Tooltip title="Align Left">
                  <IconButton
                    sx={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: !isRtl ? "#1e6a99" : "#fff",
                      boxShadow: "0 0 7px -2px #000",
                      "&:hover": {
                        backgroundColor: !isRtl ? "#1e6a99" : "#fff",
                      },
                    }}
                    onClick={() => {
                      setIsRtl(false);
                      var x = document.createElement("STYLE");
                      var t = document.createTextNode("p {text-align: start;}");
                      x.appendChild(t);
                      document.head.appendChild(x);
                    }}
                  >
                    <FormatAlignLeftIcon
                      sx={{ color: !isRtl ? "#fff" : "#000" }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Align Right">
                  <IconButton
                    sx={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: isRtl ? "#1e6a99" : "#fff",
                      boxShadow: "0 0 7px -2px #000",
                      "&:hover": {
                        backgroundColor: isRtl ? "#1e6a99" : "#fff",
                      },
                    }}
                    onClick={() => {
                      setIsRtl(true);
                      var x = document.createElement("STYLE");
                      var t = document.createTextNode("p {text-align: end;}");
                      x.appendChild(t);
                      document.head.appendChild(x);
                    }}
                  >
                    <FormatAlignRightIcon
                      sx={{ color: isRtl ? "#fff" : "#000" }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "15px 20px 0 20px",
                }}
              >
                {skeletonLoading ? (
                  <Skeleton
                    animation="wave"
                    sx={{
                      webkitTransform: "scale(1) !important",
                      transform: "scale(1) !important",
                    }}
                    width={300}
                    height={30}
                  />
                ) : (
                  <>
                    <p style={{ fontSize: "25px", color: "#000" }}>
                      Task Description
                    </p>
                    <p
                      style={{
                        height: "2.5px",
                        width: "100px",
                        backgroundColor: "#D46A43",
                        borderRadius: "5px",
                        position: "relative",
                        top: "-10px",
                      }}
                    ></p>
                  </>
                )}
              </Box>
              <Box
                sx={{
                  height: "auto",
                  maxHeight: "300px",
                  overflowY: "auto",
                  padding: "0 20px",
                  "& pre": {
                    whiteSpace: "pre-wrap",
                    // wordWrap: "break-word",
                    width: "100%",
                    height: "100%",
                  },
                }}
              >
                {props.desc.split("\n").map((i, n) => {
                  return <p key={n}>{i}</p>;
                })}
              </Box>
            </Box>
          )}
        </Box>
        {/*==============================================
       ===============third Section here=============
       ============================================== */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {skeletonLoading ? (
            <Skeleton
              animation="wave"
              sx={{
                width: "90%",
                height: "fit-content",
                minHeight: "200px",
                backgroundColor: "#f2f2f2",
                boxShadow: "0 2px 7px -2px #626262  !important",
                position: "relative",
                zIndex: "99",
                marginTop: "25px",
                borderRadius: "5px",
                webkitTransform: "scale(1) !important",
                transform: "scale(1) !important",
              }}
            />
          ) : (
            <Box
              sx={{
                width: "90%",
                height: "fit-content",
                minHeight: "200px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 7px -2px #626262 ",
                position: "relative",
                marginTop: "25px",
                zIndex: "99",
                borderRadius: "5px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "15px 20px 0 20px",
                }}
              >
                {skeletonLoading ? (
                  <Skeleton
                    animation="wave"
                    sx={{
                      webkitTransform: "scale(1) !important",
                      transform: "scale(1) !important",
                    }}
                    width={300}
                    height={30}
                  />
                ) : (
                  <>
                    <p style={{ fontSize: "25px", color: "#000" }}>
                      Task Operation
                    </p>
                    <p
                      style={{
                        height: "2.5px",
                        width: "100px",
                        backgroundColor: "#D46A43",
                        borderRadius: "5px",
                        position: "relative",
                        top: "-10px",
                      }}
                    ></p>
                  </>
                )}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  padding: "30px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    "& .MuiFab-root": {
                      backgroundColor: "#fff",
                    },
                    "& .MuiFab-root:hover": {
                      backgroundColor: "#fff",
                    },
                  }}
                >
                  <Status
                    status={props.status}
                    onRefTask={props}
                    id={props.id}
                    iconColor="#1e6a99"
                    erp_cus_id={props?.erp_cus_id}
                    allowChangeStatus={true}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexDirection: "row-reverse",
                  }}
                >
                  {props?.status !== "new" &&
                  props?.task_type === "حذف" ? null : (
                    <Tooltip title="Edit">
                      <IconButton
                        sx={{
                          width: "35px",
                          height: "35px",
                          backgroundColor: "#fff",
                          boxShadow: "0 0 7px -2px #000",
                          "&:hover": {
                            backgroundColor: "#fff",
                          },
                        }}
                        onClick={() => setShowEdit(true)}
                      >
                        <EditIcon sx={{ color: !isRtl ? "#fff" : "#000" }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title="Assign users">
                    <IconButton
                      sx={{
                        width: "35px",
                        height: "35px",
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #000",
                        "&:hover": {
                          backgroundColor: "#fff",
                        },
                      }}
                      onClick={() => setShowAssing(true)}
                    >
                      <GroupsIcon sx={{ color: !isRtl ? "#fff" : "#000" }} />
                    </IconButton>
                  </Tooltip>

                  {props.status === "rejected" &&
                  JSON.parse(localStorage.getItem("roles")).includes(7) ? (
                    <Tooltip title="Delete Task">
                      <IconButton
                        sx={{
                          width: "35px",
                          height: "35px",
                          backgroundColor: "#fff",
                          boxShadow: "0 0 7px -2px #000",
                          "&:hover": {
                            backgroundColor: "#fff",
                          },
                        }}
                        onClick={() => {
                          if (window.confirm("Delete the Task?")) {
                            Delete(props?.id);
                          }
                        }}
                      >
                        <DeleteIcon sx={{ color: !isRtl ? "#fff" : "#000" }} />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  <Tooltip title="Attache File">
                    <IconButton
                      sx={{
                        width: "35px",
                        height: "35px",
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #000",
                        "&:hover": {
                          backgroundColor: "#fff",
                        },
                      }}
                      onClick={() => setShowAttachFile(true)}
                    >
                      <AttachmentIcon
                        sx={{ color: !isRtl ? "#fff" : "#000" }}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Log">
                    <IconButton
                      sx={{
                        width: "35px",
                        height: "35px",
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #000",
                        "&:hover": {
                          backgroundColor: "#fff",
                        },
                      }}
                      onClick={() => setShowLogForm(true)}
                    >
                      <RiIcons.RiFileList3Line
                        style={{ color: !isRtl ? "#fff" : "#000" }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
        {/*==============================================
       ===============sixth Section here=============
       ============================================== */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {skeletonLoading ? (
            <Skeleton
              animation="wave"
              sx={{
                width: "90%",
                height: "fit-content",
                minHeight: "300px",
                backgroundColor: "#f2f2f2",
                boxShadow: "0 2px 7px -2px #626262  !important",
                position: "relative",
                zIndex: "99",
                marginTop: "25px",
                borderRadius: "5px",
                webkitTransform: "scale(1) !important",
                transform: "scale(1) !important",
              }}
            />
          ) : (
            <Box
              sx={{
                width: "90%",
                height: "fit-content",
                minHeight: "300px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 7px -2px #626262 ",
                position: "relative",
                marginTop: "25px",
                zIndex: "99",
                borderRadius: "5px",
                // paddingBottom:'20px'
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "15px 20px 0 20px",
                }}
              >
                {skeletonLoading ? (
                  <Skeleton
                    animation="wave"
                    sx={{
                      webkitTransform: "scale(1) !important",
                      transform: "scale(1) !important",
                    }}
                    width={300}
                    height={30}
                  />
                ) : (
                  <>
                    <p style={{ fontSize: "25px", color: "#000" }}>
                      Task Social
                    </p>
                    <p
                      style={{
                        height: "2.5px",
                        width: "100px",
                        backgroundColor: "#D46A43",
                        borderRadius: "5px",
                        position: "relative",
                        top: "-10px",
                      }}
                    ></p>
                  </>
                )}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  height: "fit-content",
                  minHeight: "400px",
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <Box
                  sx={{
                    width: "15%",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: !commentOrWorkLog
                        ? "#f3f3f3"
                        : "#bdb7b7",
                      borderLeft: !commentOrWorkLog
                        ? "5px solid #1e6a99"
                        : "none",
                      height: "60px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setCommentOrWorkLog(false);
                    }}
                  >
                    <span style={{ color: commentOrWorkLog ? "#fff" : "#000" }}>
                      Comments{" "}
                      <span
                        style={{
                          width: "30px",
                          height: "30px",
                          backgroundColor: "#1e6a99",
                          textAlign: "center",
                          color: "#fff",
                          margin: "0 5px",
                          padding: "0 5px",
                          borderRadius: "50%",
                          fontSize: "14px",
                        }}
                      >
                        {props.comments_count}
                      </span>
                    </span>
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: "85%",
                    height: "100%",
                    backgroundColor: "#f3f3f3",
                  }}
                >
                  <Comments
                    id={props.id}
                    onRefTask={props}
                    comment={props.comment}
                    comments_count={props.comments_count}
                    commentHeight={324}
                    cardColor="#f3f3f3"
                  />
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
